export default {
    bgColor: 0x2cffb3,
    primaryKey: "BGElmnts_Hrt",
    secondaryKey: "BGElmnt_Cns",
    animateIn: (data, bg)=>{
        let image = bg.create(bg.scene.mid.x, bg.scene.mid.y, data.key);
        
        image.setScale(0, 0);
        image.alpha = 0;
        let deltaScale = 1 - (data.scaleX/1);
        image.setPosition(data.x, data.y);

        bg.scene.addTween(image, 1000, {scaleX: data.scaleX, scaleY: data.scaleY, delay: deltaScale * 800}, "Back");
        bg.scene.addTween(image, 1000, {alpha: 1}, Phaser.Math.Easing.Sine.Out);
    },
    animateOut: (image, bg)=>{
        let deltaX = (image.x/bg.scene.size.width);
        bg.scene.addTween(image, 1200, {scaleX: .5, scaleY: .5, alpha: 0, x: image.x + (350 * deltaX) + 200, y: image.y + (350 * deltaX) + 200}, Phaser.Math.Easing.Sine.Out);
    },
    data:[
        {
            key: "BGElmnts_Hrt",
            x: 250.30398413133412, y: 598.5189309576838,
            angle: 0,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnts_Hrt",
            x: 891.2978767829412, y: 344.51447661469933,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Hrt",
            x: 249.02779626512157, y: 90.37861915367483,
            angle: 0,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnts_Hrt",
            x: 633.5818423834319, y: 498.3118040089087,
            angle: 0,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Hrt",
            x: 832.8655339362383, y: 562.5991091314031,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Hrt",
            x: 676.6332458990722, y: 685.7527839643652,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Hrt",
            x: 132.28119902386825, y: 377.46102449888645,
            angle: 0,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Hrt",
            x: 482.6390791997808, y: 261.1358574610245,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Hrt",
            x: 676.6465828863746, y: 182.44097995545658,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Hrt",
            x: 833.2864842292083, y: 60.44543429844098,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Hrt",
            x: 633.8980412115518, y: -9.026726057906458,
            angle: 0,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Hrt",
            x: 1040.2025734382546, y: 19.801781737193764,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Hrt",
            x: 8.837463623432383, y: 20.104677060133632,
            angle: 0,
            scaleX: 0.5999999999999996,
            scaleY: 0.5999999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 435.03529995171544, y: 449.1425389755011,
            angle: 0,
            scaleX: 0.5999999999999996,
            scaleY: 0.5999999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 482.21812890681076, y: 763.1581291759466,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Hrt",
            x: 7.85080061073484, y: 525.5345211581292,
            angle: 0,
            scaleX: 0.5999999999999996,
            scaleY: 0.5999999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 1033.7282751960747, y: 524.1135857461024,
            angle: 0,
            scaleX: 0.5999999999999996,
            scaleY: 0.5999999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 656.107544141252, y: 337.3830734966592,
            angle: 0,
            scaleX: 0.5499999999999996,
            scaleY: 0.5499999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 299.47347609912697, y: 285.0824053452116,
            angle: 0,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 467.9552780279007, y: 99.62806236080178,
            angle: 0,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 92.08503308147047, y: 206.96659242761694,
            angle: 0,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 299.90776337939946, y: 787.0133630289532,
            angle: 0,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 93.08503308147047, y: 708.8440979955457,
            angle: 0,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 958.7168826423417, y: 154.78396436525614,
            angle: 0,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 466.6790901616882, y: 603.7951002227171,
            angle: 0,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 435.9038745122604, y: -41.88195991091314,
            angle: 0,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 958.1511699226143, y: 657.5300668151448,
            angle: 0,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_Hrt",
            x: 276.8163489018518, y: 436.16926503340756,
            angle: 0,
            scaleX: 0.34999999999999964,
            scaleY: 0.34999999999999964
        },{
            key: "BGElmnts_Hrt",
            x: 891.7455010505162, y: 847.2249443207127,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        }
    ]
}